function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cr{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  className: "cr",
  x2: 15,
  transform: "translate(0.5 4.5)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cr",
  d: "M5.5,12.5h-4a1,1,0,0,1-1-1V1.5a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1v5"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cr",
  d: "M11,15l-2.5.5L9,13l4.5-4.5,2,2Z"
});

const SvgCr = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cr.a86a496d.svg";
export { ForwardRef as ReactComponent };